<template>
    <div id="setaddressComponent">
        <div class="setaddressComponent-inner">
            <div class="wz-row">
                <form role="form" action="">
                    <div class="form_group">
                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                        <gmap-autocomplete
                                class="logaddress"
                                @place_changed="setPlace"
                                placeholder="Enter shipping address"
                                :value="cart.to_address"
                                :options="{
                                        componentRestrictions:{
                                            country:['vn']
                                        },
                                    }"
                        >
                        </gmap-autocomplete>
                    </div>
                    <div class="action">
                        <button type="submit" class="btn menu-order" v-on:click="gotoMenuPage">Xem menu</button>
                        <a href="#" v-scroll-to="{el: '#step-ads', offset: 0,}" class="btn btn-km">Khuyến mãi</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SetAddress',
        data() {
            return {
                cart: this.$cart,
            };
        },
        methods: {
            setPlace(place) {
                if (place.geometry) {
                    this.cart.to_address = place.formatted_address;
                    this.cart.longitude = place.geometry.location.lng();
                    this.cart.latitude = place.geometry.location.lat();
                    sessionStorage.cart = JSON.stringify(this.cart);
                }
            },
            gotoMenuPage() {
                window.location.replace(this.$foodbookConfig.menupage);
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/SetAddress.vue